import { render, staticRenderFns } from "./AddGoodTable.vue?vue&type=template&id=5806505d&scoped=true&"
import script from "./AddGoodTable.vue?vue&type=script&lang=ts&"
export * from "./AddGoodTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806505d",
  null
  
)

export default component.exports